module.exports = __webpack_public_path__ + "img/dikologo.ac809341.svg";